import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LocaleService } from '@core/services/locale.service';
import { Observable } from 'rxjs';

@Injectable()
export class LanguageInterceptor implements HttpInterceptor {
  private readonly localeService = inject(LocaleService);
  intercept(
    req: HttpRequest<unknown>,
    next: HttpHandler,
  ): Observable<HttpEvent<unknown>> {
    const language = this.localeService.getCurrentUserLocale();
    // add language header to request
    const modifiedReq = req.clone({
      setHeaders: {
        'X-Language': language,
      },
    });

    return next.handle(modifiedReq);
  }
}
